import { render, staticRenderFns } from "./RepresentativesArea.vue?vue&type=template&id=541b5bf6&scoped=true&"
import script from "./RepresentativesArea.vue?vue&type=script&lang=js&"
export * from "./RepresentativesArea.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativesArea.vue?vue&type=style&index=0&id=541b5bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b5bf6",
  null
  
)

export default component.exports